<article class="perfil-section-card" [class.perfil-section-card--disabled]="disabled"
  [class.perfil-section-card--completa]="esCompleta" [attr.data-estado]="estado" [attr.id]="elementId || null"
  [attr.tabindex]="disabled ? -1 : 0" role="button"
  [attr.aria-label]="ariaActionLabel" [attr.aria-disabled]="disabled"
  (click)="onAction()" (keydown.enter)="onAction()" (keydown.space)="$event.preventDefault(); onAction()">
  <div class="perfil-section-card__icon" aria-hidden="true">
    <img class="perfil-section-card__img" [src]="iconSrc" alt="" width="52" height="52" />
  </div>

  <div class="perfil-section-card__body">
    <h3 class="perfil-section-card__title">{{ titulo }}</h3>
    <app-perfil-progress-section [progreso]="progresoClamped" [checkpoints]="checkpoints"
      [estado]="estado"></app-perfil-progress-section>
  </div>

  <div class="perfil-section-card__meta">
    <span class="perfil-section-card__pct">{{ progresoClamped | number: '1.0-0' }}%</span>
    <span class="perfil-section-card__action-icon" aria-hidden="true">
      <img class="perfil-section-card__action-img" [src]="actionIconSrc" alt="" width="24" height="24" />
    </span>
  </div>
</article>